var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"be-number",attrs:{"data-value":_vm.formatNumber(_vm.number, _vm.precision)}},[_vm._v(_vm._s(isFinite(_vm.number) ? _vm.formatNumber(_vm.number, _vm.precision) : 'NA'))])}
var staticRenderFns = []

export { render, staticRenderFns }